import { TabBar } from "antd-mobile";
import { TMobileRouterPath, useAppNavigate } from "../../../hooks/router";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

interface IProps {
  tabs: ITabObject[];
  tapEvent: (event: string) => void;
  /** Key of the special "More" tab that opens the customizer instead of navigating. */
  moreKey?: string;
  /** Invoked when the "More" tab is tapped. */
  onMore?: () => void;
}

let lastMainPath = "";

export const Footer: FC<IProps> = ({ tabs, tapEvent, moreKey, onMore }) => {
  const location = useLocation();

  const navigate = useAppNavigate();

  const setRouteActive = (route: string) => {
    // The "More" tab is not a route — it opens the bottom-bar customizer.
    if (moreKey && route === moreKey) {
      onMore?.();
      return;
    }
    navigate(route);
    tapEvent(route);
  };

  useEffect(() => {
    tapEvent(location.pathname);
  }, []);

  lastMainPath = tabs
    .map((val) => val.key)
    .includes(location.pathname as TMobileRouterPath)
    ? location.pathname
    : lastMainPath;

  useEffect(() => {
    const footer = document.getElementsByClassName(
      `footer-${lastMainPath}`
    )[0] as HTMLElement | null;
    if (footer) {
      // ToDo - Find a better way to handle this
      footer.onclick = () => {
        // Only called for current active tab
        navigate(lastMainPath);
      };
    }
  }, [lastMainPath, navigate]);

  return (
    <TabBar
      activeKey={lastMainPath}
      onChange={(value) => {
        setRouteActive(value);
      }}
    >
      {tabs.map((item) => {
        return (
          <TabBar.Item
            key={item.key}
            icon={item.icon}
            title={""}
            style={{ minHeight: "64px" }}
            className={`footer-${item.key}`}
          />
        );
      })}
    </TabBar>
  );
};
